/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.string().uuid(),
  createdAt: z.number(),
  updatedAt: z.number(),
  construction_id: z.string().uuid(),
  preparer_user_id: z.string().uuid(),
  stir_start_at: z.number(),
  stir_end_at: z.number(),
  construction_end_at: z.number(),
  stiring_time: z.number(),
  construct_time: z.number(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  preparer_user_id: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  preparer_user_id: true,
  deleted_at: true,
})
.extend({ id: z.string().uuid() });
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
  preparer_user_id: true,
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const ConstructionRecordBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type ConstructionRecordBase = z.infer<typeof base>;
export type ConstructionRecordBasePutPayload = z.infer<typeof put>;
export type ConstructionRecordBasePatchPayload = z.infer<typeof patch>;
export type ConstructionRecordBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type ConstructionRecordBaseCreateAttributes = z.infer<typeof create>;
export type ConstructionRecordBaseUpdateAttributes = z.infer<typeof update>;
export type ConstructionRecordBaseCacheAttributes = z.infer<typeof cache>;
export type ConstructionRecordBaseCachesAttributes = z.infer<typeof caches>;